import { createVNode as e, mergeProps as a } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/UserUnknowTwotoneStandard.js";
import d from "../components/PfIcon.js";
const o = (r, t) => {
  const n = {
    ...r,
    ...t.attrs
  };
  return e(d, a(n, {
    icon: s
  }), null);
};
o.displayName = "UserUnknowTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
